import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useI18n } from "../context/I18nContext";

export default function ProtectedRoute({ children, requirePaid = false }) {
  const { user, loading } = useAuth();
  const { t } = useI18n();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F4F4F4]" data-testid="auth-loading">
        <div className="font-mono-civic text-sm uppercase tracking-widest text-black">{t("auth_verifying")}</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  if (requirePaid && !user.has_paid) {
    return <Navigate to="/paywall" replace />;
  }

  return children;
}
